<script>
import { mapGetters } from 'vuex';
import { getInboxClassByType } from 'dashboard/helper/inbox';

export default {
  props: {
    inbox: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    ...mapGetters({
      getInboxDisplayName: 'inboxMetadata/getInboxDisplayName',
    }),
    computedInboxClass() {
      const { phone_number: phoneNumber, channel_type: type } = this.inbox;
      const classByType = getInboxClassByType(type, phoneNumber);
      return classByType;
    },
    displayNameWithFallback() {
      const displayName = this.getInboxDisplayName(this.inbox.id);
      return displayName || this.inbox.name || 'Desconhecido';
    },
  },
};
</script>

<template>
  <div
    class="inline-flex items-center px-2 py-0.5 ml-2 rounded-full bg-n-slate-3 dark:bg-n-solid-3"
  >
    <span class="text-xs text-n-slate-11 dark:text-n-slate-11 text-ellipsis overflow-hidden whitespace-nowrap max-w-[80px]">{{ displayNameWithFallback }}</span>
  </div>
</template>
